module.exports = __webpack_public_path__ + "media/images/ciberday_test-571b4962deb60def341fe5b955bb231a.png";